export const EXCEPTIONS_MESSAGE = {
  notHandledKey: (key: string) => `Not handled key: ${key}.` as const,
  noLoadedPackage: 'Can`t load package',
  incompatibleType: (varName: string, value: unknown) =>
    `${varName}: ${typeof value} is incompatible type`,
} as const;
